import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../../services/i18nService';
import styles from '../header.scss';
import storeManager from '../../../store/StoreManager';
import sessionActions from '../../../actions/SessionActions';
import sessionReader from '../../../store/readHelpers/SessionReader';
import a11yService from '../../../services/a11yService';

const SidebarButtonComponent = ({ ui, isAnnotationsSidebarOpen, isDisabled }) => {
    const fontIcon = ui.variables.header__sideBarIcon;
    const store = storeManager.getStore();
    const ariaLabel = isAnnotationsSidebarOpen ? t('header.closeSidebarButtonLabel') : t('header.openSidebarButtonLabel');

    const toggleSidebar = () => {
        if (!isAnnotationsSidebarOpen && sessionReader.isChatOpen()) {
            store.dispatch(sessionActions.setChatSidebarOpen(false));
        }
        store.dispatch(sessionActions.setAnnotationsSidebarOpen(!isAnnotationsSidebarOpen));
    };

    const onKeyDown = (e) => {
        if (e.keyCode === 9 && isAnnotationsSidebarOpen) {
            e.preventDefault();
            a11yService.focusElementWithTimeout('annotationsVisibilityButton', 'annotationsCloseButton');
        }
    };

    return (<button
        className={styles.optionsButton}
        aria-label={ariaLabel}
        onClick={toggleSidebar}
        onKeyDown={onKeyDown}
        id="toggleSidebarButton"
        disabled={isDisabled}
        aria-expanded={isAnnotationsSidebarOpen}
    >
        <span className={styles.icon}>
            <span className="sr-only">{ariaLabel}</span>
            <i className={`fa ${fontIcon} fa-3`} aria-hidden="true" />
        </span>
    </button>);
};

SidebarButtonComponent.propTypes = {
    ui: PropTypes.object,
    isAnnotationsSidebarOpen: PropTypes.bool,
    isDisabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        isAnnotationsSidebarOpen: sessionReader.isAnnotationsSidebarOpen(),
        ui: state.ui,
    };
};

const SidebarButton = connect(mapStateToProps)(SidebarButtonComponent);

export default SidebarButton;
